import { getIsArchivedForBoard } from "../../../other/utils/otherUtils";
import { getSavedBoardSelection } from "../../../react/hooks/useBoards.jsx";

const ARCHIVE_FILTER_ID = "archiveFilter";

export const SwivuStoreArchiveMixin = (Target) => class SwivuStoreArchiveMixin extends Target {
    static get $name() {
        return "SwivuStoreArchiveMixin";
    }

    static get configurable() {
        return {
            reapplyFilterOnUpdate: true,
        };
    }

    swivuArchiveStateChange() {
        const selectedBoard = getSavedBoardSelection();
        const isDisplayArchiveRecords = getIsArchivedForBoard(selectedBoard.slug)
        this.onSwivuArchiveStateChange(isDisplayArchiveRecords);
        // if this is store part of scheduler then we need to trigger archiving state on event store
        const eventStore = this.eventStore;
        if (eventStore && eventStore.onSwivuArchiveStateChange) eventStore.onSwivuArchiveStateChange(isDisplayArchiveRecords);
    }

    applyState(state) {
        super.applyState(state);
        // sometimes the state of grid may override the archive filter (if exists) in filters array, here we're handling that
        this.swivuArchiveStateChange();
    }

    static getArchivedFilter() {
        return {
            id: ARCHIVE_FILTER_ID,
            // Mark sorter hidden to not show it in the filter bar and to prevent user from deleting it
            hidden: true,
            operator: "*",
            property: "archived",
            value: false
        }
    }

    onSwivuArchiveStateChange(isDisplayArchiveRecords) {
        if (!isDisplayArchiveRecords) {
            if (!this.filters.find(s => s.id === ARCHIVE_FILTER_ID)) this.filters = [SwivuStoreArchiveMixin.getArchivedFilter(), ...this.filters];
            this.filter();
        } else this.removeFilter(ARCHIVE_FILTER_ID);
    }

    /**
     * Executes a callback function with optimized filtering for bulk operations.
     * Temporarily disables reapplyFilterOnUpdate during the operation and manually
     * reapplies filters once at the end, significantly improving performance for
     * bulk updates (e.g., archiving 1000+ records).
     *
     * @param {Function} callback - The function to execute during the bulk operation
     * @returns {*} The return value of the callback function
     */
    performBulkOperation(callback) {
        const originalReapplyFilterOnUpdate = this.reapplyFilterOnUpdate;

        try {
            // Disable automatic filter reapplication
            this.reapplyFilterOnUpdate = false;

            // Begin batch to group all updates
            this.beginBatch();

            // Execute the bulk operation
            const result = callback();

            // End batch
            this.endBatch();

            // Manually reapply filters once after all updates
            this.filter();

            return result;
        } finally {
            // Restore original setting
            this.reapplyFilterOnUpdate = originalReapplyFilterOnUpdate;
        }
    }

    /* This function is called from projectConfig.jsx line: 774, it starts the process of applying the filters of this mixin */
    swivuPerformMixinActions() {
        this.swivuArchiveStateChange();
    }
};
